var _style, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _line, _line2, _path, _polygon15, _polygon16, _path2, _circle, _path3, _circle2, _path4, _circle3, _path5, _circle4, _polygon17, _polygon18, _path6, _path7, _path8, _path9, _path10, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _defs, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _line3, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _polygon120, _polygon121, _polygon122, _polygon123, _polyline, _polyline2, _polyline3, _polyline4, _polygon124, _polygon125, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _polygon126, _path87, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _polygon136, _path88, _path89, _defs2, _polygon137, _defs3, _polygon138, _defs4, _polygon139, _defs5, _polygon140, _path90, _path91, _path92, _path93, _path94, _path95;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortAgentInOffice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 380 467.2",
    style: {
      enableBackground: "new 0 0 380 467.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#105890;}\n\t.st1{fill:none;stroke:#66CCFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#0F5387;}\n\t.st3{fill:#146EB4;}\n\t.st4{fill:#1368AB;}\n\t.st5{fill:#4F93C7;}\n\t.st6{fill:#2C7DBC;}\n\t.st7{opacity:0.4;}\n\t.st8{clip-path:url(#SVGID_2_);fill:#5B9ACB;}\n\t.st9{fill:#FFC7A4;}\n\t.st10{fill:#0A3759;}\n\t.st11{fill:#64C8FF;}\n\t.st12{opacity:5.000000e-02;}\n\t.st13{clip-path:url(#SVGID_4_);fill:#64C8FF;}\n\t.st14{clip-path:url(#SVGID_6_);fill:#64C8FF;}\n\t.st15{clip-path:url(#SVGID_8_);fill:#64C8FF;}\n\t.st16{clip-path:url(#SVGID_10_);fill:#64C8FF;}\n\t.st17{fill:#66CCFF;}\n")), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "244.2,360.6 275.9,350.1 260,316.7 176.2,265.7 159.8,283.7 167.7,313.2 180,328.6  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "195.9,216.4 122,179.5 122,116.2 195.9,153.1  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "185.3,184.8 174.8,179.5 174.8,168.9 185.3,174.2  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "185.3,200.6 174.8,195.3 174.8,184.8 185.3,190  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "164.2,158.4 153.7,153.1 153.7,142.6 164.2,147.8  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "143.1,147.8 132.5,142.6 132.5,132 143.1,137.3  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "143.1,163.7 132.5,158.4 132.5,147.8 143.1,153.1  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "159.8,172 153.7,168.9 153.7,158.4 164.2,163.7 164.2,169.8  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "164.2,169.8 159.8,167.6 159.8,172  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "143.1,179.5 132.5,174.2 132.5,163.7 143.1,168.9  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "159.8,187.8 153.7,184.8 153.7,174.2 164.2,179.5 164.2,185.6  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "164.2,185.6 159.8,183.5 159.8,187.8  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "180.9,166.7 174.8,163.7 174.8,153.1 185.3,158.4 185.3,164.5  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "185.3,164.5 180.9,162.3 180.9,166.7  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 381.4,
    y1: 429.3,
    x2: 22.6,
    y2: 249.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 22.6,
    y1: 249.9,
    x2: -40.7,
    y2: 281.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.8,340.1c-0.4-1.5-3.8-4.1-5.7-2.7c-10.7,7.7-17.4-3.2-17.5-5.2l-9.5,3.4c-0.1,4.5,0.2,11.1,0.2,11 c-1.1,4-0.5,7.6,0,9.3c0.2,0.7,0.7,1.3,1.4,1.6c2.5,1.1,5.1,2.3,7.9,1.1c0.8-0.3,1.6-0.7,3.4-1.8c1.2-0.7,1.8-3,3.3-3.7 c1.5-0.7,2-0.4,4.2-0.8c9-1.5,11.8-7.1,12.4-8.8C192.2,342.7,192.2,341.7,191.8,340.1"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "144.9,356.7 144.9,319.8 181.8,338.2  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "144.9,356.7 144.9,319.8 181.8,338.2  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M111.9,402c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1C110.5,398.9,111.9,400.3,111.9,402"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 108.8,
    cy: 402,
    r: 3.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M162.9,402c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1C161.5,398.9,162.9,400.3,162.9,402"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 159.8,
    cy: 402,
    r: 3.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M111.9,376.9c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1 C110.5,373.9,111.9,375.2,111.9,376.9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 108.8,
    cy: 376.9,
    r: 3.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M162.9,376.9c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1 C161.5,373.9,162.9,375.2,162.9,376.9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 159.8,
    cy: 376.9,
    r: 3.1
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "138.7,212.9 75.4,244.6 75.4,339.6 138.7,307.9  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "138.7,212.9 75.4,244.6 75.4,339.6 138.7,307.9  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M194.8,359l9.5-3.4c0.1,2,4,10.8,7.5,10.6l5.1-1.5l4.3,1.9l-15.7,10.7l-9.4-1C196,376.3,194.6,369.6,194.8,359 "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M195,370c0,0.2,4,2.2,8.4,1.9c6.9-0.4,12.2-2.8,12.7-4.2c0.3-1,0.3-2.5-4.4-1.6c4.6-2.2,7.6-4.7,10.1-5.3 c2.4-0.6,5.4,1.1,5.7,2.7c0.4,1.6,0.4,2.6,0.1,3.5c-0.6,1.8-3.5,7.3-12.4,8.8c-2.1,0.4-2.6,0.1-4.2,0.8c-1.5,0.7-2.1,3-3.3,3.7 c-1.9,1.1-2.7,1.5-3.4,1.8c-2.8,1.2-5.3,0-7.9-1.1c-0.7-0.3-1.2-0.9-1.4-1.6C194.5,377.6,193.8,374.1,195,370"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M182.4,297.1c0,0,6.2-2.3,10.9-2c5.6,0.4,12,3.1,12.6,16.8c0,0,4.3,32.1,5.5,37.6l1.3,6.7c0,0-1,8.4-16,10.5 c0,0-8.4,0.2-8.8-5.9l-2.9-40.8L182.4,297.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.3,281.2c1.3-0.8,4.6-2.5,6.2-2.5c2.7,0,6.7,1.1,9,4.2c0,0,2.8,4.9,1.3,22.1l-22.5,11.8l-18.9-16.4 L159.3,281.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M190.3,324l-42.5,23.8c-6.7,3.7-14.8,4.1-21.9,1.2c-10.2-4.2-22-10.4-24.4-15.3c-2.1-4.3-0.9-11.1,0.1-19.2 c0.8-6.3,2.3-13.7,2.7-16.8l44.7,14.6c0,0,29.3-13.4,33.5-15.1c6.4-2.5,10.4,0.1,13.8,3.7C199.5,304.4,198.2,318.5,190.3,324"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "307.6,297.3 244.2,329 244.2,424.1 307.6,392.4  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "307.6,297.3 244.2,329 244.2,424.1 307.6,392.4  "
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "138.5,212.8 75.4,244.6 244.2,329 307.6,297.3  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "138.5,212.8 75.4,244.6 244.2,329 307.6,297.3  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "244.2,223.5 180.9,191.8 180.9,244.6 244.2,276.2  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "244.2,223.5 180.9,191.8 180.9,244.6 244.2,276.2  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 183.6,
    y: 197.1,
    width: 58,
    height: 73.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "241.6,226.1 183.6,197.1 183.6,241.9 241.6,271  "
  }))))), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "223,276.2 180.9,255.1 159.8,265.7 202,286.8  "
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "223,276.2 180.9,255.1 159.8,265.7 202,286.8  "
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "272.4,385.3 265.3,381.8 265.3,413.4 272.4,417  "
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "272.4,385.3 265.3,381.8 265.3,413.4 272.4,417  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "318.1,365.9 275.9,387.1 275.9,418.7 318.1,397.6  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "318.1,365.9 275.9,387.1 275.9,418.7 318.1,397.6  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "275.9,387.1 272.4,385.3 272.4,417 275.9,418.7  "
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "275.9,387.1 272.4,385.3 272.4,417 275.9,418.7  "
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "314.6,364.2 307.6,360.7 265.3,381.8 272.4,385.3  "
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "314.6,364.2 307.6,360.7 265.3,381.8 272.4,385.3  "
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "318.1,365.9 314.6,364.2 272.4,385.3 275.9,387.1  "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "318.1,365.9 314.6,364.2 272.4,385.3 275.9,387.1  "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "285.6,378.7 282.9,377.4 282.9,369.5 285.6,370.8  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "285.6,378.7 282.9,377.4 282.9,369.5 285.6,370.8  "
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "298.8,372.1 296.1,370.8 296.1,365.5 298.8,366.8  "
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "298.8,372.1 296.1,370.8 296.1,365.5 298.8,366.8  "
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "288.2,369.5 285.6,370.8 285.6,378.7 288.2,377.4 288.2,372.1 298.8,366.8 298.8,372.1 301.4,370.8  301.4,365.5 301.4,362.9  "
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "288.2,369.5 285.6,370.8 285.6,378.7 288.2,377.4 288.2,372.1 298.8,366.8 298.8,372.1 301.4,370.8  301.4,365.5 301.4,362.9  "
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "301.4,362.9 285.6,370.8 282.9,369.5 298.8,361.5  "
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "301.4,362.9 285.6,370.8 282.9,369.5 298.8,361.5  "
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "293.5,395.8 286.5,392.3 286.5,424 293.5,427.5  "
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "293.5,395.8 286.5,392.3 286.5,424 293.5,427.5  "
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "339.2,376.5 297,397.6 297,429.3 339.2,408.2  "
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "339.2,376.5 297,397.6 297,429.3 339.2,408.2  "
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "297,397.6 293.5,395.8 293.5,427.5 297,429.3  "
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "297,397.6 293.5,395.8 293.5,427.5 297,429.3  "
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "335.7,374.7 328.7,371.2 286.5,392.3 293.5,395.8  "
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "335.7,374.7 328.7,371.2 286.5,392.3 293.5,395.8  "
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "339.2,376.5 335.7,374.7 293.5,395.8 297,397.6  "
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "339.2,376.5 335.7,374.7 293.5,395.8 297,397.6  "
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "306.7,389.3 304,387.9 304,380 306.7,381.3  "
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "306.7,389.3 304,387.9 304,380 306.7,381.3  "
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "319.9,382.7 317.2,381.3 317.2,376.1 319.9,377.4  "
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "319.9,382.7 317.2,381.3 317.2,376.1 319.9,377.4  "
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "309.3,380 306.7,381.3 306.7,389.3 309.3,387.9 309.3,382.7 319.9,377.4 319.9,382.7 322.5,381.3  322.5,376.1 322.5,373.4  "
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "309.3,380 306.7,381.3 306.7,389.3 309.3,387.9 309.3,382.7 319.9,377.4 319.9,382.7 322.5,381.3  322.5,376.1 322.5,373.4  "
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "322.5,373.4 306.7,381.3 304,380 319.9,372.1  "
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "322.5,373.4 306.7,381.3 304,380 319.9,372.1  "
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "314.6,406.4 307.6,402.9 307.6,434.5 314.6,438.1  "
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "314.6,406.4 307.6,402.9 307.6,434.5 314.6,438.1  "
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "360.3,387.1 318.1,408.2 318.1,439.8 360.3,418.7  "
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "360.3,387.1 318.1,408.2 318.1,439.8 360.3,418.7  "
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "318.1,408.2 314.6,406.4 314.6,438.1 318.1,439.8  "
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "318.1,408.2 314.6,406.4 314.6,438.1 318.1,439.8  "
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "356.8,385.3 349.8,381.8 307.6,402.9 314.6,406.4  "
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "356.8,385.3 349.8,381.8 307.6,402.9 314.6,406.4  "
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "360.3,387.1 356.8,385.3 314.6,406.4 318.1,408.2  "
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "360.3,387.1 356.8,385.3 314.6,406.4 318.1,408.2  "
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "327.8,399.8 325.2,398.5 325.2,390.6 327.8,391.9  "
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "327.8,399.8 325.2,398.5 325.2,390.6 327.8,391.9  "
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "341,393.2 338.3,391.9 338.3,386.6 341,387.9  "
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "341,393.2 338.3,391.9 338.3,386.6 341,387.9  "
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "330.4,390.6 327.8,391.9 327.8,399.8 330.4,398.5 330.4,393.2 341,387.9 341,393.2 343.6,391.9  343.6,386.6 343.6,384  "
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "330.4,390.6 327.8,391.9 327.8,399.8 330.4,398.5 330.4,393.2 341,387.9 341,393.2 343.6,391.9  343.6,386.6 343.6,384  "
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "343.6,384 327.8,391.9 325.2,390.6 341,382.7  "
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "343.6,384 327.8,391.9 325.2,390.6 341,382.7  "
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "111.9,236.7 130.3,245.9 156.7,232.7 138.3,223.5  "
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "111.9,236.7 130.3,245.9 156.7,232.7 138.3,223.5  "
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "111.9,234 130.3,243.3 156.7,230.1 138.3,220.8  "
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "111.9,234 130.3,243.3 156.7,230.1 138.3,220.8  "
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "111.9,231.4 130.3,240.6 156.7,227.4 138.3,218.2  "
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "111.9,231.4 130.3,240.6 156.7,227.4 138.3,218.2  "
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "111.9,228.7 130.3,238 156.7,224.8 138.3,215.6  "
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "111.9,228.7 130.3,238 156.7,224.8 138.3,215.6  "
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "111.9,226.1 130.3,235.3 156.7,222.1 138.3,212.9  "
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "111.9,226.1 130.3,235.3 156.7,222.1 138.3,212.9  "
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "111.9,223.5 130.3,232.7 156.7,219.5 138.3,210.3  "
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "111.9,223.5 130.3,232.7 156.7,219.5 138.3,210.3  "
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "111.9,220.8 130.3,230.1 156.7,216.9 138.3,207.6  "
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "111.9,220.8 130.3,230.1 156.7,216.9 138.3,207.6  "
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "111.9,218.2 130.3,227.4 156.7,214.2 138.3,205  "
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "111.9,218.2 130.3,227.4 156.7,214.2 138.3,205  "
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "111.9,215.6 130.3,224.8 156.7,211.6 138.3,202.4  "
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "111.9,215.6 130.3,224.8 156.7,211.6 138.3,202.4  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M178.6,244.9c-1.4-1.4-3.9-3.2-5.4-2.9c-1.2,0.2-4,1.7-4.8,2.4c-0.7,0.7-2,2.5-2.7,3.3 c-0.5,0.6-0.7,0.8-1.8,1.9c-0.5,0.5-2.6,1.7-3.1,2.1c-1.7,1-3.2,1.9-4.6,2.9c2.2,1.8,4,4.1,6,6.3c2.5-3.2,4.8-5.7,4.8-5.7l3.2,0.7 l3.4-1.3c1.1-0.1,2.4-1.2,2.5-2.4c0.1-1.4-3.2,0.3-4.1,0l6.4-4.2C179.3,247.2,179.5,245.7,178.6,244.9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M161.7,205.1c0,0-29,8-29.2,11c-0.5,9.1-4,14.2-4.6,16.3c-0.5,1.9,21.1,7.9,20.8,4.2 c-0.2-2.9,0.4-6.8,1.3-10.4l3.2,0.6l5.8-6.4l0.5-6.9l2.4-4.2C162.7,207.9,162.6,206.3,161.7,205.1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M113.6,230.4c3.5-2.3,8.9-3.5,15.4-3c14,1.1,20.9,7.4,25.5,10.7c11.7,8.5,10.9,28.6,10.9,28.6 s-8.2,10.4-9.7,15.2c-4.5,14.7-2.8,42-2.8,42s-3.4,9-14.9,11.4c-8.2,1.8-20.6-0.7-38.9-14.4c0,0,5.9-39.6,9.7-56.6 c0,0-6.5-2-10-7.3C98.8,257.1,100.4,240.1,113.6,230.4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M163.3,205.7c7.1-7,1.4-12.1-3.5-11.8c-3.5,0.2-13.9-5.7-18.7-1.9c-2,1.6-4.3,2.7-6,4.6 c-1.4,1.6-2.3,3.5-2.8,5.5c-0.8,3.1-0.5,6.2-0.4,9.4c0,1.8,0,3.7,0.8,5.4c0.6,1.4,1.6,3.1,3.1,3.7c2.1,0.9,4.8,0.9,7,0.2 c2.1-0.7,4-2,6-3.1c0.9-0.5,1.7-1.1,2.6-1.5c0.5-0.2,1-0.2,1.5-0.2c-0.5,0.5-1.1,1.1-1.6,1.6c-1.1,1-2,2.2-2.8,3.5 c-0.8,1.3-1.4,2.6-0.9,4.2c0.3,1.1,0.6,2.2,1.2,3.2c1.3,1.9,3.6,3.4,5.9,2.3c1.4-0.7,1.8-3.1,2.1-4.5c0.3-1.1,0.2-2.4-0.9-3.1 c-0.2-0.1-1.8-0.6-1.8-0.6c0,0-0.1-4.7-0.1-6.7c0.2-0.4,3-7.4,3-7.4C159.1,206.4,161.7,207.2,163.3,205.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M176.6,288.2c0,0-4.4-0.1-5.7-0.7c-7.2-3.4-16.1-8.1-26-24c-9.9-15.8,6.3-20.5,12.9-15.3 c7.8,6.1,19.3,27.5,19.3,27.5s4.2-4.8,10.7-9.4c1.4-1,2.9-2.7,3.9-5.5l-0.3-2.5l0.6-4.2l2.1-1.3l1.2-2.9c0.4-0.9,1.4-1.3,2.2-0.9 l1.9,0.8l3,4.5c0.3,0.5,0.4,1.1,0.2,1.7l-0.7,2.2l-3.5,5.7l-1.8,3.2l-1.5,4.2C195.2,271.4,188.1,288.1,176.6,288.2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M169.3,258.5c0,0-8.3,12.6-27.5,12.6c0,0-12.3-23.5,1.2-30.5C143,240.7,162.4,228.4,169.3,258.5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M222.1,288.9l8.2,4.1c0.5,0.2,1.1,0.2,1.6,0l16.1-8.1c0.6-0.3,0.6-1.2,0-1.6l-8.2-4.1c-0.5-0.2-1.1-0.2-1.6,0 l-16.1,8.1C221.4,287.6,221.4,288.6,222.1,288.9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.1,288.9l8.2,4.1c0.5,0.2,1.1,0.2,1.6,0l16.1-8.1c0.6-0.3,0.6-1.2,0-1.6l-8.2-4.1c-0.5-0.2-1.1-0.2-1.6,0 l-16.1,8.1C221.4,287.6,221.4,288.6,222.1,288.9z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 243.4,
    y1: 283.7,
    x2: 239.8,
    y2: 282
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "241.6,301.3 260.1,310.5 286.5,297.3 268,288.1  "
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "241.6,301.3 260.1,310.5 286.5,297.3 268,288.1  "
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "241.6,298.7 260.1,307.9 286.5,294.7 268,285.5  "
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "241.6,298.7 260.1,307.9 286.5,294.7 268,285.5  "
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "241.6,296 260.1,305.3 286.5,292.1 268,282.8  "
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "241.6,296 260.1,305.3 286.5,292.1 268,282.8  "
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "164.2,374.7 140.5,386.6 140.5,384 164.2,372.1  "
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "164.2,374.7 140.5,386.6 140.5,384 164.2,372.1  "
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "104.4,374.7 128.1,386.6 128.1,384 104.4,372.1  "
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "104.4,374.7 128.1,386.6 128.1,384 104.4,372.1  "
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "104.4,398.5 110.6,401.6 110.6,398.9 104.4,395.8  "
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "104.4,398.5 110.6,401.6 110.6,398.9 104.4,395.8  "
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "164.2,398.5 158.1,401.6 158.1,398.9 164.2,395.8  "
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "164.2,398.5 158.1,401.6 158.1,398.9 164.2,395.8  "
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "164.2,372.1 158.1,369 134.3,380.9 110.6,369 104.4,372.1 128.1,384 104.4,395.8 110.6,398.9  134.3,387.1 158.1,398.9 164.2,395.8 140.5,384  "
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "164.2,372.1 158.1,369 134.3,380.9 110.6,369 104.4,372.1 128.1,384 104.4,395.8 110.6,398.9  134.3,387.1 158.1,398.9 164.2,395.8 140.5,384  "
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "134.3,389.7 110.6,401.6 110.6,398.9 134.3,387.1  "
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "134.3,389.7 110.6,401.6 110.6,398.9 134.3,387.1  "
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "134.3,389.7 158.1,401.6 158.1,398.9 134.3,387.1  "
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "134.3,389.7 158.1,401.6 158.1,398.9 134.3,387.1  "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M139.6,369H129v15.4h0c0,0.6,0.5,1.3,1.6,1.8c3.7,1.9,8.9,0.2,8.9-1.8h0L139.6,369L139.6,369z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.6,369H129v15.4h0c0,0.6,0.5,1.3,1.6,1.8c3.7,1.9,8.9,0.2,8.9-1.8h0L139.6,369L139.6,369z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M130.6,370.9c-4.9-2.4,2.4-6.1,7.3-3.7C142.9,369.6,135.5,373.3,130.6,370.9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.6,370.9c-4.9-2.4,2.4-6.1,7.3-3.7C142.9,369.6,135.5,373.3,130.6,370.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M137.8,340.9h-7v27.3h0c0,0.4,0.3,0.8,1.1,1.2c2.5,1.2,5.9,0.1,6-1.2h0L137.8,340.9L137.8,340.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.8,340.9h-7v27.3h0c0,0.4,0.3,0.8,1.1,1.2c2.5,1.2,5.9,0.1,6-1.2h0L137.8,340.9L137.8,340.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M131.9,342.1c-3.3-1.6,1.6-4.1,4.9-2.4C140,341.3,135.1,343.7,131.9,342.1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.9,342.1c-3.3-1.6,1.6-4.1,4.9-2.4C140,341.3,135.1,343.7,131.9,342.1z"
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "139.6,311.9 86.8,285.5 92.1,282.8 144.9,309.2  "
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "139.6,311.9 86.8,285.5 92.1,282.8 144.9,309.2  "
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "139.6,364.6 86.8,338.2 86.8,285.5 139.6,311.9  "
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "139.6,364.6 86.8,338.2 86.8,285.5 139.6,311.9  "
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "-72.4,234 -51.3,223.5 -51.3,170.7  "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "-104,249.9 -82.9,239.3 -82.9,186.5  "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "-72.4,170.7 -51.3,160.1 -51.3,139  "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "-104,186.5 -82.9,176 -82.9,154.9  "
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "144.9,356.7 144.9,309.2 139.6,311.9 139.6,364.6 181.8,343.5 181.8,338.2  "
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "144.9,356.7 144.9,309.2 139.6,311.9 139.6,364.6 181.8,343.5 181.8,338.2  "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M268.2,125.4V123l2.8-1.4c0,0,0.1-0.1,0.1-0.1v-6.1l3-1.5c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1-0.1-0.2l-1.1-1.6 c0-0.1-0.1-0.1-0.2-0.1l-2.4-1.1l-3.1-4.6c0-0.1-0.1-0.1-0.2-0.1l-2.9-1.4c-0.1,0-0.1,0-0.2,0l-1.9,1l-3.5-1.7c-0.1,0-0.1,0-0.2,0 l-3.2,1.6l-3.5-1.7c-0.1-0.1-0.2,0-0.2,0.1v2.6c0,0.1,0,0.1,0.1,0.2l2.6,3.8c0,0.1,0.1,0.1,0.2,0.1l1.1,0.5v6.9l-1.7,0.9 c0,0-0.1,0.1-0.1,0.1v6.4c0,0.1,0,0.1,0.1,0.2l3.2,4.8c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l2.7-1.4c0,0,0.1-0.1,0.1-0.1v-2.3 l3.3,1.6c0.1,0,0.1,0,0.2,0l4.7-2.4C268.2,125.5,268.2,125.5,268.2,125.4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.1,93.8c0,0.1,0.1,0.1,0.2,0.1s0.1,0,0.2,0l1-0.5l0.4,0.6c0.1,0.1,0.2,0.2,0.3,0.2l1.2-0.6 c0,0,0.1-0.1,0.1-0.1s0-0.1-0.1-0.2l-1.3-1.9c-0.1-0.1-0.2-0.2-0.3-0.2l-2.4,1.2c0,0-0.1,0.1-0.1,0.1s0,0.1,0.1,0.2L231.1,93.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.8,95c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l1.3-0.7c0.1,0,0.1-0.2,0-0.3l-0.9-1.3 c0-0.1-0.1-0.1-0.2-0.1l-0.9-0.4c-0.1,0-0.1,0-0.2,0l-0.5,0.3c0,0-0.1,0.1-0.1,0.1v0.7c0,0.1,0,0.1,0.1,0.2L236.8,95z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.9,97.2l-3.3-1.6c-0.1-0.1-0.2,0-0.2,0.1v0.7c0,0.1,0.1,0.3,0.2,0.3l3.3,1.6c0.1,0.1,0.2,0,0.2-0.1v-0.7 C194.1,97.4,194,97.3,193.9,97.2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.9,197.9l-1.4-0.7c-0.1-0.1-0.2,0-0.2,0.1v1.8c0,0.1,0.1,0.3,0.2,0.3l1.4,0.7c0.1,0.1,0.2,0,0.2-0.1v-1.8 C250.1,198.1,250,197.9,249.9,197.9z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M225.4,148l-1.7-0.8c-0.1-0.1-0.2,0-0.2,0.1v1.7c0,0.1,0.1,0.3,0.2,0.3l1.7,0.8c0.1,0.1,0.2,0,0.2-0.1v-1.7 C225.6,148.2,225.5,148.1,225.4,148z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.3,97.7c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l2-1l2.1,1c0.1,0.1,0.2,0,0.2-0.1v-1.7 c0-0.1-0.1-0.3-0.2-0.3l-3.2-1.6c-0.1,0-0.1,0-0.2,0l-2.4,1.2c-0.1,0-0.1,0.2,0,0.3L226.3,97.7z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.2,115c-0.1-0.1-0.2,0-0.2,0.1v1.7c0,0.1,0.1,0.3,0.2,0.3l2.4,1.1c0.1,0.1,0.2,0,0.2-0.1v-1.7 c0-0.1-0.1-0.3-0.2-0.3L238.2,115z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.7,99.1l-2.4-1.2c-0.1,0-0.1,0-0.2,0l-1.4,0.7c0,0-0.1,0.1-0.1,0.1v3.5c0,0.1,0,0.1,0.1,0.2l2.4,3.6 c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l3.3-1.7c0.1,0,0.1-0.2,0-0.3l-1.8-2.7v-2.1C232.9,99.3,232.8,99.1,232.7,99.1z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.1,95.1c0-0.1-0.1-0.3-0.2-0.3l-1.2-0.6c-0.1,0-0.1,0-0.2,0l-1.3,0.7c-0.1,0-0.1,0.2,0,0.3l1.7,2.5 c0,0.1,0.1,0.1,0.2,0.1l3.6,1.8c0.1,0.1,0.2,0,0.2-0.1V98c0-0.1,0-0.1-0.1-0.2l-0.7-1.1v-1.4c0-0.1-0.1-0.2-0.1-0.3 c-0.1-0.1-0.2-0.1-0.2-0.1l-1.3,0.6c0,0-0.1,0.1-0.1,0.1v0.5l-0.3-0.2L234.1,95.1L234.1,95.1z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.1,100.6l1.2,0.6c0.1,0.1,0.2,0,0.2-0.1v-0.8l0.7-0.4c0,0,0.1-0.1,0.1-0.1s0-0.1-0.1-0.2l-1.1-1.7 c0-0.1-0.1-0.1-0.2-0.1l-0.7-0.4c-0.1,0-0.1,0-0.2,0l-0.7,0.3c0,0-0.1,0.1-0.1,0.1v0.9c0,0.1,0,0.1,0.1,0.2l0.5,0.7v0.6 C237.9,100.4,238,100.5,238.1,100.6z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.7,99.3c0,0-0.1,0.1-0.1,0.1c0,0.4,0,0.9,0,0.9c0,0.1,0,0.1,0.1,0.2l0.8,1.2v2.4c0,0.1,0.1,0.3,0.2,0.3 l1.5,0.7l1,1.5c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l1.1-0.5c0.1,0,0.1-0.2,0-0.3l-2.1-3.1c0-0.1-0.1-0.1-0.2-0.1l-0.2-0.1 v-2.1c0-0.1-0.1-0.3-0.2-0.3l-2.1-1C240.8,99.3,240.7,99.3,240.7,99.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.5,95.8l1,1.5c0,0.1,0.1,0.1,0.2,0.1l2,1c0.1,0,0.1,0,0.2,0l0.7-0.4c0,0,0.1-0.1,0.1-0.1v-2.4 c0-0.1,0-0.1-0.1-0.2l-1.9-2.8c-0.1-0.1-0.2-0.2-0.3-0.2l-1.7,0.9c-0.1,0-0.1,0.2,0,0.3l0.9,1.3l-1,0.5 C238.4,95.5,238.4,95.7,238.5,95.8z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.6,99.6c0,0.1,0.1,0.1,0.2,0.1l1.6,0.8c0.1,0,0.1,0,0.2,0l1-0.5c0,0,0.1-0.1,0.1-0.1v-2.2l0.6-0.3 c0,0,0.1-0.1,0.1-0.1s0-0.1-0.1-0.2l-0.6-1v-1.2c0-0.1-0.1-0.3-0.2-0.3l-0.8-0.4c-0.1,0-0.1,0-0.2,0l-1.6,0.8c0,0-0.1,0.1-0.1,0.1 v2.1l-0.4-0.2c-0.1-0.1-0.2,0-0.2,0.1v1.4c0,0.1,0,0.1,0.1,0.2L243.6,99.6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M247.2,98.3v3.7l-2.1-1c-0.1,0-0.1,0-0.2,0l-1.4,0.7c0,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0.1,0.2l2.4,3.6 c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l4.5-2.3c0,0,0.1-0.1,0.1-0.1v-1.5l1.7,0.8c0.1,0,0.1,0,0.2,0l2-1l1.7,0.8 c0.1,0,0.1,0,0.2,0l2-1c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1-0.1-0.2l-2.3-3.4c0-0.1-0.1-0.1-0.2-0.1l-4.5-2.2c-0.1,0-0.1,0-0.2,0 l-1,0.5l-2.2-1.1c-0.1-0.1-0.2,0-0.2,0.1v2.2c0,0.1,0,0.1,0.1,0.2l1.1,1.7l-1.8-0.9C247.3,98.2,247.2,98.2,247.2,98.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M235.9,145.5l-3.2-1.6c-0.1-0.1-0.2,0-0.2,0.1v0.8c0,0.1,0.1,0.3,0.2,0.3l2,1l1.9,2.8c0,0.1,0.1,0.1,0.2,0.1 l1.9,0.9c0.1,0,0.2,0,0.2,0c0-0.1,0-0.2,0-0.3l-2.7-4C236,145.5,236,145.5,235.9,145.5z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.7,105.9C236.7,105.9,236.7,105.9,236.7,105.9c0.1,0.1,0.3,0.1,2.1-1l1.5,0.7c0.1,0.1,0.2,0,0.2-0.1v-2.4 c0-0.1-0.1-0.3-0.2-0.3l-1.9-0.9l-0.7-1.1c-0.1-0.1-0.2-0.2-0.3-0.2l-1.4,0.7l-1.2-0.6c-0.1-0.1-0.2,0-0.2,0.1v1.7 c0,0.1,0,0.1,0.1,0.2l1.9,2.9C236.6,105.8,236.7,105.8,236.7,105.9z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243,116c-0.1,0-0.1,0.2,0,0.3l2.6,3.8c0,0.1,0.1,0.1,0.2,0.1l1.8,0.9c0.1,0.1,0.2,0,0.2-0.1V119l1.2,1.8 c0.1,0.1,0.2,0.2,0.3,0.2l1.3-0.7c0.1,0,0.1-0.2,0-0.3l-2.2-3.2v-4.2c0-0.1,0-0.1-0.1-0.2l-2.9-4.3c0-0.1-0.1-0.1-0.2-0.1l-1.8-0.9 l-1.1-1.6c-0.1-0.1-0.2-0.2-0.3-0.2l-2.5,1.3c-0.1,0-0.1,0.2,0,0.3l2.8,4.2c0,0.1,0.1,0.1,0.2,0.1l1.7,0.8v3.3L243,116z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.7,173.1l-5-2.4l-8.9-13.3c0-0.1-0.1-0.1-0.2-0.1l-7.9-3.8c-0.1,0-0.1,0-0.2,0l-1.6,0.8l-4.4-6.5v-2.9 c0-0.1-0.1-0.3-0.2-0.3l-4.7-2.3v-3l2.6-1.3l5.1,2.5l1.7,2.6c0.1,0.1,0.2,0.2,0.3,0.2l0.6-0.3c0,0,0.1-0.1,0.1-0.1v-3.1l7.7-4 l2.5,1.2c0.1,0.1,0.2,0,0.2-0.1v-3c0-0.1-0.1-0.3-0.2-0.3l-2.6-1.3l1-0.5l5.3,2.6c0.1,0.1,0.2,0,0.2-0.1v-3.5c0-0.1,0-0.1-0.1-0.2 l-3.1-4.6c-0.1-0.1-0.2-0.2-0.3-0.2l-1.9,1v-5.8c0-0.1,0-0.1-0.1-0.2l-2-3c-0.1-0.1-0.2-0.2-0.2-0.2c-0.1,0-0.1,0.1-0.1,0.1v2.7 l-3.1,1.6c0,0-0.1,0.1-0.1,0.1v4.3l-2.6-3.9c0-0.1-0.1-0.1-0.2-0.1l-1.7-0.8l-2.9-4.3l4.9-2.5c0,0,0.1-0.1,0.1-0.1v-1.2l4.8,2.3 c0.1,0.1,0.2,0,0.2-0.1v-3.5c0-0.1-0.1-0.3-0.2-0.3l-3.1-1.5v-2.3c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.2-0.1l-3,1.5l-4.3-2.1 l-7-10.5c0-0.1-0.1-0.1-0.2-0.1l-5.3-2.6l-5.2-7.8c0-0.1-0.1-0.1-0.2-0.1l-6-2.9c-0.1,0-0.1,0-0.2,0l-4.4,2.3l-2.3-1.1 c-0.1-0.1-0.2,0-0.2,0.1v2.2c0,0.1,0,0.1,0.1,0.2l1.9,2.9l-3.2,1.6c0,0-0.1,0.1-0.1,0.1v3.8l-3.8,2c0,0-0.1,0.1-0.1,0.1 c0,0.1,0,0.1,0.1,0.2l1.1,1.7c0.1,0.1,0.2,0.2,0.3,0.2l3-1.5l2.6,1.3c0.1,0,0.1,0,0.2,0l2.5-1.3l4.9,2.4l4.9,7.3v8.3l-3.6,1.8 c0,0-0.1,0.1-0.1,0.1v7.4c0,0.1,0,0.1,0.1,0.2l6.9,10.2v2.7c0,0.1,0.1,0.3,0.2,0.3l4.3,2.1l10.6,15.7c0,0.1,0.1,0.1,0.2,0.1 l2.4,1.2v2.4l-2.1,1.1c0,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0.1,0.2l7.1,10.6v10l-2.2,1.1c0,0-0.1,0.1-0.1,0.1v7.5c0,0.1,0,0.1,0.1,0.2 l7,10.4c0,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1-0.1v-4.8c0-0.1,0-0.1-0.1-0.2l-2.3-3.4l3.3-1.7 c0,0,0.1-0.1,0.1-0.1v-4.4l6.3-3.2l2.8,1.4c0.1,0.1,0.2,0,0.2-0.1v-5.8l2.9-1.5c0,0,0.1-0.1,0.1-0.1v-3.8 C258.9,173.3,258.8,173.2,258.7,173.1z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.6,191.8c0,0-0.1,0.1-0.1,0.1v0.6l-1.5-0.7c-0.1,0-0.1,0-0.2,0l-1.4,0.7c0,0-0.1,0.1-0.1,0.1v1.7 c0,0.1,0,0.1,0.1,0.2l1.1,1.6c0,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1-0.1V194l0.5-0.3l1.8,0.9c0.1,0,0.1,0,0.2,0 l0.3-0.1l1.3,0.6c0.1,0,0.1,0,0.2,0l0.7-0.4c0.1,0,0.1-0.2,0-0.3l-0.7-1.1v-3.2c0-0.1,0-0.1-0.1-0.2l-0.4-0.5v-0.9l0.3,0.5 c0.1,0.1,0.2,0.2,0.3,0.2l1-0.5c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1-0.1-0.2l-0.4-0.6l0.8-0.4c0.1,0,0.1-0.1,0-0.2 c0-0.1-0.1-0.2-0.2-0.2l-0.9-0.5c-0.1,0-0.1,0-0.2,0l-0.6,0.3l-1.2-1.8c-0.1-0.1-0.2-0.2-0.3-0.2l-0.7,0.4c-0.1,0-0.1,0.2,0,0.3 l0.8,1.2l-1,0.5c0,0-0.1,0.1-0.1,0.1s0,0.1,0.1,0.2l1,1.5v2.3L352.6,191.8z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.6,142.5c0,0.1,0.1,0.1,0.2,0.1l2.4,1.2c0.1,0,0.2,0,0.2,0c0-0.1,0-0.2,0-0.3l-2-3c0-0.1-0.1-0.1-0.2-0.1 l-1.5-0.7c-0.1-0.1-0.2,0-0.2,0.1v0.9c0,0.1,0,0.1,0.1,0.2L333.6,142.5z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.1,142.8l1.9,0.9c0.1,0.1,0.2,0,0.2-0.1v-1.1c0-0.1-0.1-0.3-0.2-0.3l-1.9-0.9c-0.1-0.1-0.2,0-0.2,0.1v1.1 C335.9,142.6,336,142.7,336.1,142.8z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.7,144.2c-0.1-0.1-0.2,0-0.2,0.1v1.3c0,0.1,0.1,0.3,0.2,0.3l1.3,0.6c0.1,0.1,0.2,0,0.2-0.1v-1.3 c0-0.1-0.1-0.3-0.2-0.3L335.7,144.2z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.9,185.5c0.1,0.1,0.2,0,0.2-0.1v-2.6c0-0.1-0.1-0.3-0.2-0.3l-1.3-0.6c-0.1-0.1-0.2,0-0.2,0.1v2.6 c0,0.1,0.1,0.3,0.2,0.3L358.9,185.5z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.5,195.5v0.8c0,0.1,0.1,0.3,0.2,0.3l0.8,0.4c0.1,0.1,0.2,0,0.2-0.1v-0.8c0-0.1-0.1-0.3-0.2-0.3l-0.8-0.4 C348.6,195.3,348.5,195.3,348.5,195.5z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.1,197.9c0.1,0.1,0.2,0,0.2-0.1v-1.9c0-0.1-0.1-0.3-0.2-0.3l-0.9-0.4c-0.1-0.1-0.2,0-0.2,0.1v1.9 c0,0.1,0.1,0.3,0.2,0.3L347.1,197.9z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.6,202v2c0,0.1,0,0.1,0.1,0.2l0.9,1.4c0,0.1,0.1,0.1,0.2,0.1l1.2,0.6c0.1,0,0.2,0,0.2,0c0-0.1,0-0.2,0-0.3 l-1.1-1.6l0.4-0.2c0,0,0.1-0.1,0.1-0.1V203c0-0.1-0.1-0.3-0.2-0.3l-1.4-0.7C345.7,201.9,345.6,201.9,345.6,202z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.4,205.7v2c0,0.1,0.1,0.3,0.2,0.3l0.5,0.3c0.1,0.1,0.2,0,0.2-0.1v-2c0-0.1-0.1-0.3-0.2-0.3l-0.5-0.3 C345.5,205.5,345.4,205.5,345.4,205.7z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.9,208c0.1,0.1,0.2,0,0.2-0.1V207c0-0.1-0.1-0.3-0.2-0.3l-0.6-0.3c-0.1-0.1-0.2,0-0.2,0.1v0.9 c0,0.1,0.1,0.3,0.2,0.3L347.9,208z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.4,208.9l-1.1-0.5c-0.1-0.1-0.2,0-0.2,0.1v0.8c0,0.1,0.1,0.3,0.2,0.3l0.7,0.4l0.6,0.9 c0,0.1,0.1,0.1,0.2,0.1l1.2,0.6c0.1,0.1,0.2,0,0.2-0.1v-1.5c0-0.1,0-0.1-0.1-0.2l-0.7-1c0,0,0-0.1-0.1-0.1l0.3,0.2 c0.1,0.1,0.2,0,0.2-0.1v-1.1c0-0.1-0.1-0.3-0.2-0.3l-1.1-0.5c-0.1-0.1-0.2,0-0.2,0.1v1.1c0,0.1,0.1,0.3,0.2,0.3l0.5,0.3 c0,0,0,0-0.1,0L348.4,208.9z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.4,246.6l-2.5-1.2c-0.1-0.1-0.2,0-0.2,0.1v2.2c0,0.1,0,0.1,0.1,0.2l0.8,1.3c0,0.1,0.1,0.1,0.2,0.1 c0.1,0,0.1,0,0.2,0l1.7-0.9c0,0,0.1-0.1,0.1-0.1V247C358.6,246.8,358.5,246.7,358.4,246.6z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.7,254.6c0-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.1,0-0.2,0l-2.7,1.4l-0.9-0.4c-0.1,0-0.1,0-0.2,0l-1.5,0.8 c0,0-0.1,0.1-0.1,0.1v1.2c0,0.1,0,0.1,0.1,0.2l0.9,1.4c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l2.6-1.3c0,0,0.1-0.1,0.1-0.1v-0.7 l0.7,0.3c0.1,0,0.1,0,0.2,0l1.4-0.7c0,0,0.1-0.1,0.1-0.1v-0.8c0-0.1,0-0.1-0.1-0.2L371.7,254.6z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.3,253.9l-0.7-0.3V252c0-0.1,0-0.1-0.1-0.2l-1.1-1.6c-0.1-0.1-0.2-0.2-0.2-0.2c-0.1,0-0.1,0.1-0.1,0.1v2.6 l-1,0.5c-0.1,0-0.1,0.2,0,0.3l0.9,1.3v0.9c0,0.1,0.1,0.2,0.1,0.3c0,0,0.1,0,0.1,0.1c0.1,0,0.1,0,0.2,0l1.3-0.6c0,0,0.1-0.1,0.1-0.1 V255l0.7,0.3c0.1,0.1,0.2,0,0.2-0.1v-0.9C375.5,254.2,375.4,254,375.3,253.9z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.4,223.6l-1.1-0.5c-0.1-0.1-0.2,0-0.2,0.1v2c0,0.1,0.1,0.3,0.2,0.3l1.1,0.5c0.1,0.1,0.2,0,0.2-0.1v-2 C364.7,223.8,364.6,223.7,364.4,223.6z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.3,228.2l2.9,1.4c0.1,0.1,0.2,0,0.2-0.1v-0.9c0-0.1-0.1-0.3-0.2-0.3l-2.9-1.4c-0.1-0.1-0.2,0-0.2,0.1v0.9 C366.1,228,366.2,228.2,366.3,228.2z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.9,236.8l2.1,3.1c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l0.7-0.3c0.1,0,0.1-0.2,0-0.3l-2.1-3.1 c-0.1-0.1-0.2-0.2-0.3-0.2l-0.7,0.3C368.8,236.6,368.8,236.7,368.9,236.8z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.3,232.2v-3.1c0-0.1,0-0.1-0.1-0.2l-1.4-2.1c-0.1-0.1-0.2-0.2-0.2-0.2c-0.1,0-0.1,0.1-0.1,0.1v2.6 l-1.7-0.8L355,226l0.9-0.5c0.1,0,0.1-0.1,0-0.2c0-0.1-0.1-0.2-0.2-0.2l-3.4-1.6c-0.1,0-0.1,0-0.2,0l-1.6,0.8l-1-1.5 c-0.1-0.1-0.2-0.2-0.3-0.2l-4,2l-2.3-1.1c-0.1,0-0.1,0-0.2,0l-2.2,1.1c0,0-0.1,0.1-0.1,0.1v4.6c0,0.1,0,0.1,0.1,0.2l0.8,1.2 l-0.9,0.5c-0.1,0-0.1,0.2,0,0.3l1.9,2.9c0.1,0.1,0.2,0.2,0.3,0.2l1.6-0.8l2.7,1.3c0.1,0,0.1,0,0.2,0l1.7-0.8l1.4,0.7l2.7,4.1v1 c0,0.1,0,0.1,0.1,0.2l2.1,3.1c0,0.1,0.1,0.1,0.2,0.1l3.6,1.8c0.1,0,0.1,0,0.2,0l1.7-0.9c0,0,0.1-0.1,0.1-0.1v-1.6l2.8-1.4 c0,0,0.1-0.1,0.1-0.1v-3.6c0-0.1,0-0.1-0.1-0.2L360.3,232.2z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.3,217.8c0-0.1-0.1-0.1-0.2-0.1l-2-1c-0.1-0.1-0.2,0-0.2,0.1v0.9c0,0.1,0.1,0.3,0.2,0.3l1.5,0.7l1.8,2.7 l-0.7,0.4c-0.1,0-0.1,0.2,0,0.3l1.2,1.8c0,0.1,0.1,0.1,0.2,0.1l2,1c0.1,0,0.1,0,0.2,0l1.1-0.6l1.7,2.5c0,0.1,0.1,0.1,0.2,0.1 l1.3,0.6c0.1,0,0.2,0,0.2,0c0-0.1,0-0.2,0-0.3L362,225l-3.3-5c0-0.1-0.1-0.1-0.2-0.1l-2.7-1.3L355.3,217.8z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.4,208.3c-0.1,0-0.1,0-0.2,0l-3.1,1.6l-0.8-0.4c-0.1-0.1-0.2,0-0.2,0.1v1.1c0,0.1,0,0.1,0.1,0.2l1.8,2.7 c0,0.1,0.1,0.1,0.2,0.1l1.7,0.8c0.1,0.1,0.2,0,0.2-0.1v-0.9l1.5-0.8c0,0,0.1-0.1,0.1-0.1s0-0.1-0.1-0.2l-0.7-1.1l1.1-0.6 c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1-0.1-0.2l-1.4-2.1C344.6,208.4,344.5,208.3,344.4,208.3z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.4,212.5v-2.2c0-0.1-0.1-0.3-0.2-0.3l-1-0.5V209c0-0.1,0-0.1-0.1-0.2l-3-4.5c0-0.1-0.1-0.1-0.2-0.1 l-1.5-0.7c-0.1,0-0.2,0-0.2,0c0,0.1,0,0.2,0,0.3l2.1,3.1v1c0,0.1,0,0.1,0.1,0.2l2.7,3.9c0,0.1,0.1,0.1,0.2,0.1l0.9,0.5 C338.3,212.7,338.4,212.6,338.4,212.5z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.2,217.1c0,0.1,0.1,0.1,0.2,0.1l1.1,0.5c0.1,0.1,0.2,0,0.2-0.1v-1c0-0.1-0.1-0.3-0.2-0.3l-0.9-0.4l-1-1.5 c0-0.1-0.1-0.1-0.2-0.1l-2.8-1.4c-0.1,0-0.1,0-0.2,0L338,213c-0.1,0-0.1,0.2,0,0.3l0.8,1.2c0,0.1,0.1,0.1,0.2,0.1l2.4,1.2 L342.2,217.1z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.9,214.1l-0.8-1.2c0-0.1-0.1-0.1-0.2-0.1c-0.1,0-0.1,0-0.2,0l-1.9,1c0,0-0.1,0.1-0.1,0.1v2.3 c0,0.1,0.1,0.3,0.2,0.3l2,1c0.1,0.1,0.2,0,0.2-0.1v-1.5c0-0.1,0-0.1-0.1-0.2l-0.4-0.6l1.1-0.6C348.9,214.4,348.9,214.3,348.9,214.1 z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348,218.7l-2.8-1.4c-0.1-0.1-0.2,0-0.2,0.1v0.7c0,0.1,0.1,0.3,0.2,0.3l2.8,1.4c0.1,0.1,0.2,0,0.2-0.1V219 C348.2,218.9,348.1,218.8,348,218.7z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.5,218.6v-0.7c0-0.1-0.1-0.3-0.2-0.3l-2.8-1.4c-0.1-0.1-0.2,0-0.2,0.1v0.7c0,0.1,0.1,0.3,0.2,0.3l2.8,1.4 C352.4,218.7,352.5,218.7,352.5,218.6z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.2,219.9c-0.1-0.1-0.2,0-0.2,0.1v1.1c0,0.1,0.1,0.3,0.2,0.3l0.6,0.3c0.1,0.1,0.2,0,0.2-0.1v-1.1 c0-0.1-0.1-0.3-0.2-0.3L349.2,219.9z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.7,198.8c-0.1-0.1-0.2-0.2-0.3-0.2l-0.9,0.5c-0.1,0-0.1,0.2,0,0.3l0.7,1c0,0.1,0.1,0.1,0.2,0.1 c0.1,0,0.1,0,0.2,0l0.9-0.5c0.1,0,0.1-0.2,0-0.3L324.7,198.8z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M307.7,201.2l-1.7-0.8c-0.1,0-0.1,0-0.2,0l-2.6,1.3c0,0-0.1,0.1-0.1,0.1v2.5l-1.3,0.7c-0.1,0-0.1,0.2,0,0.3 l1.5,2.2c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l2.7-1.4c0,0,0.1-0.1,0.1-0.1v-2.1l1.4-0.7c0,0,0.1-0.1,0.1-0.1v-1.7 C307.9,201.4,307.8,201.2,307.7,201.2z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M302.4,142.1c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l1.1-0.6c0.1,0,0.1-0.2,0-0.3l-1.6-2.4v-2.8l2.7-1.4 c0,0,0.1-0.1,0.1-0.1V133c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1l-4.4,2.3c0,0-0.1,0.1-0.1,0.1v3.5c0,0.1,0,0.1,0.1,0.2 L302.4,142.1z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.1,129.1l1.1,0.6c0.1,0,0.1,0,0.2,0l1.1-0.6c0,0,0.1-0.1,0.1-0.1s0-0.1-0.1-0.2l-1.5-2.2 c-0.1-0.1-0.2-0.2-0.3-0.2l-0.8,0.4c0,0-0.1,0.1-0.1,0.1v1.8C309.9,128.8,310,129,310.1,129.1z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.9,130.3l1.2,1.8c0,0.1,0.1,0.1,0.2,0.1l2.8,1.4c0.1,0.1,0.2,0,0.2-0.1v-1.9c0-0.1-0.1-0.3-0.2-0.3 l-1.7-0.8l-0.7-1.1c-0.1-0.1-0.2-0.2-0.3-0.2l-1.5,0.8C311.9,130,311.9,130.2,311.9,130.3z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.7,126.6c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l0.6-0.3c0,0,0.1-0.1,0.1-0.1v-2.9c0-0.1,0-0.1-0.1-0.2 l-1.5-2.2c0-0.1-0.1-0.1-0.2-0.1l-0.7-0.3c-0.1,0-0.1,0-0.2,0l-1,0.5c0,0-0.1,0.1-0.1,0.1v1.4c0,0.1,0,0.1,0.1,0.2L284.7,126.6z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.4,123.5c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l1.2-0.6c0.1,0,0.1-0.2,0-0.3l-0.8-1.2 c0-0.1-0.1-0.1-0.2-0.1l-1.7-0.9c-0.1,0-0.1,0-0.2,0c0,0-0.1,0.1-0.1,0.1v0.8c0,0.1,0,0.1,0.1,0.2L286.4,123.5z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.2,124.6l1.7,0.8c0.1,0.1,0.2,0,0.2-0.1v-1.5c0-0.1-0.1-0.3-0.2-0.3l-1.7-0.8c-0.1-0.1-0.2,0-0.2,0.1v1.5 C293.9,124.4,294,124.6,294.2,124.6z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.4,124.8l0.8,0.4c0.1,0.1,0.2,0,0.2-0.1v-1.3c0-0.1-0.1-0.3-0.2-0.3l-0.8-0.4c-0.1-0.1-0.2,0-0.2,0.1v1.3 C297.2,124.6,297.3,124.8,297.4,124.8z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.2,125.8v1.2c0,0.1,0.1,0.3,0.2,0.3l1.2,0.6c0.1,0.1,0.2,0,0.2-0.1v-1.2c0-0.1-0.1-0.3-0.2-0.3l-1.2-0.6 C298.3,125.6,298.2,125.7,298.2,125.8z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.4,160.5c0.1,0.1,0.2,0,0.2-0.1v-2c0-0.1-0.1-0.3-0.2-0.3l-1.5-0.7c-0.1-0.1-0.2,0-0.2,0.1v2 c0,0.1,0.1,0.3,0.2,0.3L283.4,160.5z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.6,144.3c-0.1,0-0.1,0.2,0,0.3l1.1,1.6c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l1.5-0.8 c0.1,0,0.1-0.2,0-0.3l-1.1-1.6c-0.1-0.1-0.2-0.2-0.3-0.2L272.6,144.3z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.1,134.2l2.1-1.1c0.1,0,0.1-0.2,0-0.3l-1.2-1.8c-0.1-0.1-0.2-0.2-0.3-0.2l-1.3,0.7l-1-1.5 c-0.1-0.1-0.2-0.2-0.3-0.2l-0.8,0.4c-0.1,0-0.1,0.2,0,0.3l0.4,0.6v1.6c0,0.1,0.1,0.3,0.2,0.3l2,1C270,134.2,270,134.2,270.1,134.2z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.7,145.4l-1.3,0.7c-0.1,0-0.1,0.2,0,0.3l0.4,0.5l-0.9,0.5c0,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0.1,0.2 l0.8,1.2c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0l1.3-0.7l1,0.5c0.1,0,0.1,0,0.2,0l1.6-0.8c0,0,0.1-0.1,0.1-0.1 c0-0.1,0-0.1-0.1-0.2l-2.3-3.4v-1.3c0-0.1,0-0.1-0.1-0.2l-1.2-1.7c-0.1-0.1-0.2-0.2-0.3-0.2l-1.7,0.9c0,0-0.1,0.1-0.1,0.1 s0,0.1,0.1,0.2L276.7,145.4z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.9,156.6c0-0.1-0.1-0.1-0.2-0.1l-10.1-4.9c-0.1,0-0.1,0-0.2,0l-2.7,1.4l-2.9-1.4c-0.1,0-0.1,0-0.2,0 l-0.7,0.3l-1.3-2c0-0.1-0.1-0.1-0.2-0.1l-4.6-2.2c-0.1,0-0.1,0-0.2,0l-3,1.5l-2-1l-2.1-3.2c0-0.1-0.1-0.1-0.2-0.1l-6.8-3.3 l-1.8-5.3c0-0.1-0.1-0.2-0.2-0.2l-4.3-2.1c-0.1,0-0.1,0-0.2,0l-3.2,1.6c0,0-0.1,0.1-0.1,0.1v3.8l-4.2,2.2l-3.4-1.7 c-0.1-0.1-0.2,0-0.2,0.1v6.4l-5.4-2.7c-0.1,0-0.1,0-0.2,0L297,146l-1.1-1.6l1.9-1c0.1,0,0.1-0.2,0-0.3l-3.3-4.8 c0-0.1-0.1-0.1-0.2-0.1l-5.2-2.6c-0.1,0-0.1,0-0.2,0l-8.2,4.2c0,0-0.1,0.1-0.1,0.1v3.2c0,0.1,0.1,0.3,0.2,0.3l1.8,0.9l1.6,2.4 c0.1,0.1,0.2,0.2,0.3,0.2l2.4-1.2c0,0,0.1-0.1,0.1-0.1s0-0.1-0.1-0.2l-1.3-2l2.7-1.4l1.3,0.6v3.4c0,0.1,0,0.1,0.1,0.2l1.9,2.9 l-3.7,1.9l-5.3-2.6c-0.1,0-0.1,0-0.2,0l-3.3,1.7l-2.1-1c-0.1,0-0.1,0-0.2,0l-3.4,1.7c0,0-0.1,0.1-0.1,0.1v3c0,0.1,0.1,0.3,0.2,0.3 l4.1,2c0.1,0,0.1,0,0.2,0l2.6-1.4l2.4,1.2l2.5,3.8v2.2c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.2,0.1l1.8-0.9c0.1,0,0.1-0.2,0-0.3 l-2.4-3.5v-0.7l5.2,7.7c0.1,0.1,0.2,0.2,0.3,0.2l1.9-1c0,0,0.1-0.1,0.1-0.1v-2.5l7.4,3.6l-1.9,1l-4-2c-0.1,0-0.1,0-0.2,0l-1.1,0.6 c0,0-0.1,0.1-0.1,0.1v2.5c0,0.1,0.1,0.3,0.2,0.3l4.8,2.3l-2,1l-8.8-4.3l-2.5-3.7c0-0.1-0.1-0.1-0.2-0.1l-9.9-4.8 c-0.1,0-0.1,0-0.2,0l-6.1,3.1c0,0-0.1,0.1-0.1,0.1v6.3c0,0.1,0,0.1,0.1,0.2l5.3,8c0,0.1,0.1,0.1,0.2,0.1l5.6,2.7l4.5,6.6v9.2 c0,0.1,0,0.1,0.1,0.2l3.1,4.6v6.8c0,0.1,0.1,0.3,0.2,0.3l5,2.5c0.1,0,0.1,0,0.2,0l6-3.1c0,0,0.1-0.1,0.1-0.1v-4.9l2.9-1.5 c0,0,0.1-0.1,0.1-0.1v-4.4l5.3-2.7c0,0,0.1-0.1,0.1-0.1v-3.1c0-0.1-0.1-0.3-0.2-0.3l-3.2-1.6l-6.4-9.5v-1.2l6,9 c0,0.1,0.1,0.1,0.2,0.1l4.4,2.1c0.1,0,0.1,0,0.2,0l4.6-2.3c0.1,0,0.1-0.2,0-0.3l-1.6-2.4l4.6,2.3l3.1,4.7v3.5c0,0.1,0,0.1,0.1,0.2 l3.7,5.4c0.1,0.1,0.2,0.2,0.3,0.2l1.8-0.9c0,0,0.1-0.1,0.1-0.1v-3l3.3-1.7l3.3,4.9c0.1,0.1,0.2,0.2,0.3,0.2l0.8-0.4l1.3,2v3.1 c0,0.1,0,0.1,0.1,0.2l1.2,1.7v1.1c0,0.1,0,0.1,0.1,0.2l1.3,2c0.1,0.1,0.2,0.2,0.3,0.2l1.2-0.6c0,0,0.1-0.1,0.1-0.1s0-0.1-0.1-0.2 l-2.5-3.8v-2.1l1.3,2c0,0.1,0.1,0.1,0.2,0.1l1.9,0.9c0.1,0,0.1,0,0.2,0l1.1-0.6c0,0,0.1-0.1,0.1-0.1v-1.4c0-0.1,0-0.1-0.1-0.2 l-1.7-2.5v-2.8l3.8,1.9c0.1,0,0.1,0,0.2,0l3.1-1.6c0,0,0.1-0.1,0.1-0.1v-5.1c0-0.1,0-0.1-0.1-0.2l-3.1-4.7l1-0.5l2.2,3.2 c0,0.1,0.1,0.1,0.2,0.1l2.2,1.1c0.1,0.1,0.2,0,0.2-0.1V187l3.7-1.9c0,0,0.1-0.1,0.1-0.1v-6.3c0-0.1,0-0.1-0.1-0.2l-3.2-4.7v-5 l3.1,1.5c0.1,0.1,0.2,0,0.2-0.1v-0.7l1.5,0.7c0.1,0.1,0.2,0,0.2-0.1v-1.4l1-0.5l1.4,0.7c0.1,0.1,0.2,0,0.2-0.1v-1.1l0.7,1v2.3 l-0.8,0.4c0,0-0.1,0.1-0.1,0.1v3.7c0,0.1,0,0.1,0.1,0.2l1.2,1.7v1.8c0,0.1,0,0.1,0.1,0.2l1.7,2.5c0,0.1,0.1,0.1,0.2,0.1l1.3,0.7 c0.1,0.1,0.2,0,0.2-0.1v-6.9c0-0.1,0-0.1-0.1-0.2l-1.6-2.4v-2.1l2.6,1.3c0.1,0.1,0.2,0,0.2-0.1v-2.9l2.3-1.2c0.1,0,0.1-0.2,0-0.3 l-1.4-2l2.6-1.4c0,0,0.1-0.1,0.1-0.1v-1.7c0-0.1,0-0.1-0.1-0.2L361.9,156.6z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 22.6,
    y1: 249.9,
    x2: 22.6,
    y2: 154.9
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 200.3,
    y1: 233.1,
    x2: 202.9,
    y2: 234.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 191.5,
    y1: 228.7,
    x2: 194.1,
    y2: 230.1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 195.9,
    y1: 230.9,
    x2: 198.5,
    y2: 232.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 191.5,
    y1: 239.3,
    x2: 194.1,
    y2: 240.6
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 195.9,
    y1: 241.5,
    x2: 198.5,
    y2: 242.8
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 200.3,
    y1: 243.7,
    x2: 202.9,
    y2: 245
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 191.5,
    y1: 234,
    x2: 194.1,
    y2: 235.3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 195.9,
    y1: 236.2,
    x2: 198.5,
    y2: 237.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 200.3,
    y1: 238.4,
    x2: 202.9,
    y2: 239.7
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 191.5,
    y1: 231.4,
    x2: 194.1,
    y2: 232.7
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 195.9,
    y1: 233.6,
    x2: 198.5,
    y2: 234.9
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 200.3,
    y1: 235.8,
    x2: 202.9,
    y2: 237.1
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 191.5,
    y1: 236.7,
    x2: 194.1,
    y2: 238
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 195.9,
    y1: 238.9,
    x2: 198.5,
    y2: 240.2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 200.3,
    y1: 241.1,
    x2: 202.9,
    y2: 242.4
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "200.6,218 190.7,213.1 190.7,211.5 192.1,212.2 192.1,210.9 194.9,212.3 194.2,210.7 194.2,210.4  201.4,214 201.4,214.3 200.6,215.1  "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M187.7,211.6l2.3,1.1l0.4,0.6l37.8,18.8v-0.9l9.8,4.9c0,0,0.2,0.1,0.1,0.2l-3,2l-48-23.9v-2.6 C187,211.8,187,211.3,187.7,211.6"
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "192.9,208.4 197.1,210.5 197.1,210.8 192.9,208.6  "
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "193.1,207.9 197,209.8 197.1,210.4 193,208.3  "
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "193.8,210.6 194.3,211.6 192.2,210.6 192.8,208.8 197.1,210.9 197.2,211.5 193.8,209.8  "
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "206.2,218 206.2,220.8 205.8,220.6 205.9,217.9 205.5,217.7 205.4,217.4 205.9,217.7 205.9,217.1  206.1,217.2 206.2,217.8 206.7,218 206.6,218.2  "
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "215.1,222.5 215.2,225.3 214.8,225.1 214.9,222.4 214.5,222.2 214.4,221.9 214.9,222.1 214.9,221.5  215.1,221.6 215.1,222.3 215.7,222.5 215.5,222.7  "
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "223.5,226.6 223.5,229.5 223.1,229.3 223.2,226.5 222.8,226.3 222.7,226 223.2,226.3 223.2,225.7  223.4,225.8 223.4,226.4 224,226.7 223.9,226.8  "
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "198.1,210.5 200,211.4 200.5,213.2 198.2,212  "
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "198.1,209.5 199.7,210.3 199.9,210.9 198.1,210.1  "
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "193.9,206.4 195.8,207.4 196.3,209.1 194,208  "
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "193.8,205.4 195.5,206.3 195.7,206.9 193.9,206  "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M235,240.1c0.4,0.7,0,1.7-1.2,1c0,0-42.8-21.4-43.9-21.9c0,0-0.9-0.5-1.2-1.5c0,0-0.2-0.6-0.8-1.2 c-0.7-0.6-0.8-1-0.8-1.7l47.7,23.8C234.7,239,234.6,239.4,235,240.1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M227.4,289.7c-0.8-0.4,0.4-1,1.2-0.6C229.4,289.5,228.2,290.1,227.4,289.7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -51.3,
    y: 297.3,
    width: 63.3,
    height: 31.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "-9.1,329 -51.3,307.9 -30.2,297.3 12.1,318.5  "
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 1.5,
    y: 323.7,
    width: 42.2,
    height: 21.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "22.6,344.8 1.5,334.3 22.6,323.7 43.7,334.3  "
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -82.9,
    y: 313.2,
    width: 63.3,
    height: 31.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "-40.7,344.8 -82.9,323.7 -61.8,313.2 -19.6,334.3  "
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: -30.2,
    y: 339.6,
    width: 42.2,
    height: 21.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "-9.1,360.7 -30.2,350.1 -9.1,339.6 12.1,350.1  "
  }))))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M220.5,246.8c1,0.5,1.8,0.1,1.8-0.9c0-1-0.8-2.2-1.8-2.6c-1-0.5-1.8-0.1-1.8,0.9 C218.7,245.1,219.5,246.3,220.5,246.8z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M220.5,247.7c-0.9-0.4-3.5-1.3-3.5,0v4c0,0.2,0.2,0.5,0.4,0.7l6.2,3.1c0.2,0.1,0.4,0,0.4-0.2v-4 C224,249.8,221.4,248.1,220.5,247.7z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M210.8,241.9c1,0.5,1.8,0.1,1.8-0.9c0-1-0.8-2.2-1.8-2.6c-1-0.5-1.8-0.1-1.8,0.9 C209.1,240.3,209.8,241.5,210.8,241.9z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M210.8,242.8c-0.9-0.4-3.5-1.3-3.5,0v4c0,0.2,0.2,0.5,0.4,0.7l6.2,3.1c0.2,0.1,0.4,0,0.4-0.2v-4 C214.3,245,211.7,243.3,210.8,242.8z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M230.2,251.6c1,0.5,1.8,0.1,1.8-0.9c0-1-0.8-2.2-1.8-2.6c-1-0.5-1.8-0.1-1.8,0.9 C228.4,249.9,229.2,251.1,230.2,251.6z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M230.2,252.5c-0.9-0.4-3.5-1.3-3.5,0v4c0,0.2,0.2,0.5,0.4,0.7l6.2,3.1c0.2,0.1,0.4,0,0.4-0.2v-4 C233.7,254.7,231.1,252.9,230.2,252.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortAgentInOffice);
export default __webpack_public_path__ + "static/media/port-agent-in-office.eafe5954f37889b7a03f3cf37bffc961.svg";
export { ForwardRef as ReactComponent };